import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function setSessionToken(token) {
  if (token) sessionStorage.setItem("bbc.session_token", token);
  else sessionStorage.removeItem("bbc.session_token");
}
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("bbc.session_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// --- WebSocket Real-Time Infrastructure ---
let socket = null;
const listeners = new Set();
let reconnectTimer = null;

export function connectWebSocket() {
  if (socket) {
    socket.onclose = null;
    socket.close();
  }
  const token = sessionStorage.getItem("bbc.session_token");
  if (!token) return;

  const wsUrl = API.replace(/^http/, "ws") + "/ws?token=" + encodeURIComponent(token);

  socket = new WebSocket(wsUrl);

  socket.onmessage = (e) => {
    try {
      const msg = JSON.parse(e.data);
      listeners.forEach((l) => l(msg));
    } catch {}
  };

  socket.onclose = () => {
    clearTimeout(reconnectTimer);
    reconnectTimer = setTimeout(connectWebSocket, 5000);
  };

  socket.onerror = () => {
    socket?.close();
  };
}

export function addWsListener(l) {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
